//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wcs from '@/scripts/libs/wcs'
const headerLoginUrl = wcs.getEndPoint('headerLoginUrl')

export default {
  name: 'rb-plp-wishlist-modal-content',
  data() {
    return {
      loginUrl: headerLoginUrl,
    }
  },
}
